import { Form, Select } from 'antd';
import { useContext } from 'react';

import { LegacyHotelContext } from 'app/context/HotelContext/LegacyHotelContext';

import { RULES } from '../BulkEdit';

type RoomSelectorProps = {
  initialRoomId?: number;
  onChange: (value: string) => void;
};

export const RoomSelector = ({
  initialRoomId,
  onChange,
}: RoomSelectorProps) => {
  const { hasAtLeastOneDayPackage, roomsFromPublishedPackages } =
    useContext(LegacyHotelContext);

  return (
    <section className="bulkEdit__body__selected-room">
      <h2>Selected {hasAtLeastOneDayPackage ? 'time' : 'room'}</h2>
      <div className="room-select">
        <Form.Item name="roomId" initialValue={initialRoomId} rules={RULES}>
          <Select
            onChange={onChange}
            disabled={!!initialRoomId}
            options={roomsFromPublishedPackages.map((room) => ({
              label: room.name,
              value: room.id,
            }))}
            placeholder="Select a room"
          />
        </Form.Item>
      </div>
    </section>
  );
};
